import { render, staticRenderFns } from "./delegateList.vue?vue&type=template&id=2d63f762&scoped=true"
import script from "./delegateList.vue?vue&type=script&lang=js"
export * from "./delegateList.vue?vue&type=script&lang=js"
import style0 from "./delegateList.vue?vue&type=style&index=0&id=2d63f762&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d63f762",
  null
  
)

export default component.exports